import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'filterArray'
})
export class FilterArrayPipe implements PipeTransform {

    transform(items: any[], searchText: string, property): any[] {

        if (searchText === '') {
            return items;
        }

        searchText = searchText.toLowerCase();

        return items.filter(itemObj => {
            return itemObj[property].toLowerCase().includes(searchText);
        });
    }
}




// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/pipesFiles/filter.pipe.ts